export default function convertHxBxT(value) {
	if (!value || !value.trim()) return value
	return value
		.trim()
		.split('x')
		.map((e) => {
			const normalizedValue = e.trim().replace(',', '.')
			const number = Number(normalizedValue)
			return Number.isFinite(number) ? number.toLocaleString('de-DE') : e.trim()
		})
		.join(' x ')
}
